import { text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box, Typography } from "@mui/material";
import { FC } from "react";

type TRegularTopPageWarningProps = {};

export const RegularTopPageWarning: FC<TRegularTopPageWarningProps> = ({}) => {
  return (
    <Box bgcolor="#FFF3E0" border="1px solid #EC7126" padding={2} borderRadius={rounded.xs}>
      <Typography variant="body14Bold" component="p">
        制度変更により、2025年4月1日〜2026年3月31日分から年1回の定期届出提出となります。初回提出期日は
        <Typography component="span" color={text.accent} variant="body14Bold">
          2026年5月31日
        </Typography>
        です。
      </Typography>
    </Box>
  );
};
